import type { SurveyLikertPointCount } from './survey-question.types'

export const LIKERT_POINT_COUNT_MIN = 1
export const LIKERT_POINT_COUNT_MAX = 10

export function isSurveyLikertPointCount(n: number): n is SurveyLikertPointCount {
  return Number.isInteger(n) && n >= LIKERT_POINT_COUNT_MIN && n <= LIKERT_POINT_COUNT_MAX
}

/** Default respondent labels for common 3 / 5 / 7 sizes; other sizes fall back to point numbers. */
export function defaultLikertLabels(count: SurveyLikertPointCount): string[] {
  switch (count) {
    case 3:
      return ['Disagree', 'Neutral', 'Agree']
    case 5:
      return ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree']
    case 7:
      return [
        'Strongly Disagree',
        'Disagree',
        'Slightly Disagree',
        'Neutral',
        'Slightly Agree',
        'Agree',
        'Strongly Agree',
      ]
    default:
      return Array.from({ length: count }, (_, i) => String(i + 1))
  }
}

export function resolveLikertLabels(
  count: SurveyLikertPointCount,
  rawLabels: unknown,
): string[] {
  const defaults = defaultLikertLabels(count)
  const raw = Array.isArray(rawLabels) ? rawLabels : []
  return Array.from({ length: count }, (_, i) => {
    const v = raw[i]
    if (typeof v === 'string' && v.trim()) return v.trim()
    return defaults[i] ?? String(i + 1)
  })
}
